import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
    *{
        margin: 0;
        padding: 0;
        box-sizing: border-box;

        ::-webkit-scrollbar {
            width: 10px;
        }

        /* Track */
        ::-webkit-scrollbar-track {
            background: #f1f1f1;
        }

        /* Handle */
        ::-webkit-scrollbar-thumb {
            background: #f9b290;
        }

        /* Handle on hover */
        ::-webkit-scrollbar-thumb:hover {
            background: #f26522;
        }
    }
    html{
        font-size: 88%;
        font-family: 'Poppins', sans-serif;

        .MuiListItemIcon-root{
            color: #f26522;
        }
        .MuiFormLabel-root.Mui-focused{
            color: #f26522;
        }

        .Toastify__toast--default {
        }
        .Toastify__toast--info {
        }
        .Toastify__toast--success {
            background: #3ba559;
          /* color: #000; */
        }
        .Toastify__toast--warning {
            background: #ccc659;
            color: #000;
        }
        .Toastify__toast--error {
        }

        .loading {
            /* height: calc(100vh - 10px); */
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
        }
        .__json-pretty__ {
            background: #fff;
        }
        .__json-pretty__ .__json-key__ {
            color: #F26522;
        }
        .__json-pretty__ .__json-string__ {
            color: #333;
        }
        .__json-pretty__ .__json-value__ {
            color: #722;
        }

    }
    body{
        background-color: #f1f1f1;
    }

`;
